export default __webpack_public_path__ + "static/media/send.d12f77e4.svg";